import { COLOR_CODES } from '../../constant/colors';
import './ClientDetailCard.scss';
type AppProps = {
    name?: string | undefined;
}


const backColor=(name:any)=>{
   switch(name[0].toLowerCase()){
    case "a" :
    case "k" :
    case "u" :return  COLOR_CODES[0]
    case "b" :
    case "l" :
    case "v" :return  COLOR_CODES[1]
    case "c" : 
    case "m" : 
    case "w" :return  COLOR_CODES[2]
    case "d" :
    case "n" :
    case "x" :return  COLOR_CODES[3]
    case "e" : 
    case "o" :
    case "y" :return  COLOR_CODES[4]
    case "f" : 
    case "p" :
    case "z" :return  COLOR_CODES[5]
    case "g" : 
    case "q" : 
    case "j" :return  COLOR_CODES[6]
    case "h" :
    case "r" :
    case "t" :return  COLOR_CODES[7]
    case "i" : 
    case "s" :return  COLOR_CODES[8]
    default : return   COLOR_CODES[9];
   }
}

const ClientDashboardAvatar = ({name}: AppProps) => {

    let finalName = name?.split(' ')[0].slice(0,1);

    let avatarBgColor = backColor(name)

    return (
      <div className="ClientAvatarWrap size48" 
      style={{backgroundColor: avatarBgColor}}
      >
        {finalName?finalName: 'AN'}
      </div>
    )
  }
  
export default ClientDashboardAvatar;